/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs */

const en__field__enum_teachingsubjectinterest_subject_catholic_religion25 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catholic Religion`)
};

const de__field__enum_teachingsubjectinterest_subject_catholic_religion25 = /** @type {(inputs: _Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katholische Religion`)
};

/**
* | output |
* | --- |
* | "Catholic Religion" |
*
* @param {_Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_teachingsubjectinterest_subject_catholic_religion25 = /** @type {((inputs?: _Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Teachingsubjectinterest_Subject_Catholic_Religion25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_teachingsubjectinterest_subject_catholic_religion25(inputs)
	return de__field__enum_teachingsubjectinterest_subject_catholic_religion25(inputs)
});
export { _field__enum_teachingsubjectinterest_subject_catholic_religion25 as "_field__enum_teachingSubjectInterest_SUBJECT_CATHOLIC_RELIGION" }